import { render, staticRenderFns } from "./Faldon.vue?vue&type=template&id=7c29520a"
import script from "./Faldon.vue?vue&type=script&lang=js"
export * from "./Faldon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports